import { Link } from "react-router-dom";
import React, { useState } from "react";
import PlusIcon from "assets/Home/Plus.svg";
import MinusIcon from "assets/Home/Minus.svg";
import { faqs } from "../../constant/Home/MainPage";

export default function FrequentlyAskedQuestions({
  chipStyles = "bg-[#3CAB5C1A] text-[#3CAB5C] border border-[#3CAB5C]",
  padding = "md:px-12 px-5",
  id,
}) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div id={id} className="lg:max-w-[1440px] w-full mx-auto">
      {" "}
      <section
        className={`flex   w-full mx-auto flex-col gap-4 md:gap-8 lg:gap-[64px] text-white py-8  lg:py-[64px] ${padding}`}
      >
        <div className=" grid md:grid-cols-2 lg:gap-16 md:gap-12 gap-8 items-start">
          <div className="flex flex-col justify-between max-w-[535px] h-full lg:min-h-[400px] sm2:pb-[42px]">
            <div className="flex flex-col gap-2 md:gap-4 lg:gap-6">

              <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full  border border-[#3CAB5C] font-medium w-fit">
                What Makes Properteasy Different
              </h5>


              <h1 className="font-medium w-full text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
                Frequently Asked Questions
              </h1>

              <h2
                style={{ letterSpacing: "0.025em" }}
                className="text-[#242424] w-full text-[18px] md:text-[22px] "
              >
                Got questions? We've got answers. Find everything you need to
                know about using Properteasy.
              </h2>
            </div>

            <Link to="/legal" className="text-[#2c8d48] w-fit border-b-2 border-[#2c8d48] text-[20px] font-semibold hover:underline">View all</Link>
          </div>

          {/* Right Column */}
          <div className="w-full divide-y divide-gray-200 border-[#dadada] border-t border-b">
            {faqs.map((faq, index) => (
              <div key={index} className="py-6">
                <div
                  onClick={() => toggle(index)}
                  className="flex justify-between cursor-pointer"
                >
                  <h3
                    className={` text-[20px] ${
                      openIndex === index
                        ? "text-[#242424] font-semibold"
                        : "text-[#595959]"
                    }`}
                  >
                    {faq.question}
                  </h3>
                  <span>
                    {openIndex === index ? (
                      <img src={MinusIcon}></img>
                    ) : (
                      <img src={PlusIcon}></img>
                    )}
                  </span>
                </div>
                {openIndex === index && faq.answer && (
                  <p className="text-[16px] text-[#333333] font-medium mt-4 leading-relaxed">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
